import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FileInputButton from "../../../../components/fileInputButton";
import IconButton from "@mui/material/IconButton";
import { Loader } from "./styles";
import { getBase64 } from "../../../../utils/utils";
import serviceRebalanceUsinaHistoricoGeracao from "@/services/serviceRebalanceUsinaHistoricoGeracao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    returnDate: (item: string[]) => void;
    onClose?: any;
}

export default function DialogLoad({ open, onClose, onSuccess, returnDate }: IDialogProps) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileBase64, setSelectedFileBase64] = useState("");
    const [isDisable, setDisable] = useState(false);
    const [messageList, setMessageList] = useState([]);

    const {
        handleSubmit,
        reset,
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {},
    });

    const handleFileInput = (e: any) => {
        const extension = e.target.files[0].name.split(".").pop().toLowerCase();

        if (["csv"].includes(extension)) {
            setSelectedFile(e.target.files[0]);

            getBase64(e.target.files[0]).then((result) => {
                setSelectedFileBase64(result);
            });
        } else {
            toast.error("O arquivo selecionado é inválido. É necessário anexar no formato CSV!");
            clearFile();
        }
    };

    useEffect(() => {
        if (messageList.length > 0) {
            returnDate(messageList);
        }
    }, [messageList]);

    const onSubmit = (values: any) => {
        setDisable(true);

        if (!selectedFile || !selectedFileBase64) {
            toast.error("É necessário anexar o arquivo (CSV).");
            setDisable(false);
        } else {
            const chargeValues = {
                fileBase64: selectedFileBase64.replace("data:text/csv;base64,", ""),
            };
            serviceRebalanceUsinaHistoricoGeracao
                .create(chargeValues)
                .then((result) => {
                    if (result.data && result.data.length > 0) {
                        setMessageList(result.data);
                    }
                    if (result && result.data && result.data.errors.length <= 0) {
                        toast.success("Arquivo carregado com sucesso!");
                    }
                })
                .finally(() => {
                    setDisable(false);
                    clearFile();
                    onClose(true);
                    reset();
                    onSuccess();
                });
        }
    };

    const onCancelLoad = () => {
        clearFile();
        reset();
        onClose(true);
    };

    const clearFile = () => {
        setSelectedFile(null);
        setSelectedFileBase64("");
    };

    return (
        <Dialog
            maxWidth="sm"
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Novo
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            onCancelLoad();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            {isDisable && (
                                <Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </Loader>
                            )}
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <FileInputButton accept="text/csv" onChange={handleFileInput} selectedFile={selectedFile} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={() => onCancelLoad()}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Carregar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
